import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import { useWechat } from '@/hooks/useWechat'
import { nextTick } from 'vue'



const routes = [
  {
    path: '/',
    redirect: () => {
      // --- 新的逻辑 ---
      // 定义活动开始和结束时间 (注意月份是从0开始的，所以5月是4)
      const promoStartDate = new Date(2025, 3, 30, 17, 15, 0); // 2025年5月1日 00:00:00
      const promoEndDate = new Date(2025, 4, 31, 23, 59, 59); // 2025年5月31日 23:59:59

      // 获取当前时间
      const now = new Date();

      // 判断当前时间是否在活动期间内
      const isPromoActive = now >= promoStartDate && now <= promoEndDate;
      console.log('promoStartDate:', promoStartDate);
      console.log('promoEndDate:', promoEndDate);
      console.log('now:', now);
      console.log('isPromoActive:', isPromoActive);

      // 根据是否在活动期间返回不同的路径
      return isPromoActive ? '/9th-anniversary' : '/home';
      // --- 新的逻辑结束 ---
    }
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    keepAlive: true,
    meta: {title: 'DV·生活商城'}
  },
  {
    path: '/public-notice',
    name: 'PublicNotice',
    component: () => import('@/views/PublicNotice.vue'),
    meta: { requiresAuth: false, title: '公示' }
  },
  {
    path: '/agreement',
    name: 'PublicAgreement',
    component: () => import('@/views/agreement/PublicAgreement.vue'),
    meta: { requiresAuth: false, title: '用户协议与隐私政策' }
  },
  {
    path: '/category',
    name: 'Category',
    component: () => import('@/views/Category.vue'),
    meta: {
      requiresAuth: false,
      keepAlive: true,
      title: 'DV·生活商城 - 分类'
    }
  },
  // {
  //   path: '/my-center',
  //   name: 'MyCenter',
  //   component: () => import('../views/MyCenter.vue'),  // 使用懒加载
  //   meta: {
  //     requiresAuth: false,
  //     keepAlive: true,
  //     title: 'DV·个人中心'
  //   }
  // },
  {
    path: '/my-center',
    name: 'MyCenter',
    component: () => import('../views/MyCenter.vue'),  // 使用懒加载
    meta: {
      requiresAuth: false,
      keepAlive: true,
      title: 'DV·个人中心'
    }
  },
  {
    path: '/category-detail',
    name: 'CategoryDetail',
    component: () => import('../views/CategoryDetail.vue'),
    meta: {
      requiresAuth: false,
      keepAlive: true,
      title: 'DV·生活商城 - 分类详情'
    }
  },
  {
    path: '/feature-zone',
    name: 'FeatureZone',
    component: () => import('../views/FeatureZone.vue'),
    meta: {
      requiresAuth: false,
      keepAlive: true,
      title: 'DV·生活商城 - 功能专区'
    }
  },
  {
    path: '/spring-festival',
    name: 'SpringFestival',
    component: () => import('../views/SpringFestival.vue'),
    meta: {
      requiresAuth: false,
      keepAlive: true,
      title: 'DV·年货节'
    }
  },
  {
    path: '/search',
    name: 'ProductSearch',
    component: () => import('../views/search/ProductSearch.vue'),  // 使用懒加载
    meta: {
      requiresAuth: false,
      keepAlive: true,
      title: 'DV·搜索'
    }
  },
  {
    path: '/search-result',
    name: 'SearchResult',
    component: () => import('../views/search/SearchResult.vue'),  // 使用懒加载
    meta: {
      requiresAuth: false,
      keepAlive: true,
      title: 'DV·搜索结果'
    }
  },
  {
    path: '/member-center',
    name: 'MemberCenter',
    component: () => import('../views/MemberCenter.vue'),  // 使用懒加载
    meta: {
      requiresAuth: false,
      keepAlive: true,
      title: 'DV·会员中心'
    }
  },
  {
    path: '/coupon-list',
    name: 'CouponList',
    component: () => import('../views/mycenter/CouponList.vue'),  // 使用懒加载
    meta: {
      requiresAuth: false,
      keepAlive: true,
      title: 'DV·优惠券'
    }
  },
  {
    path: '/score-list',
    name: 'ScoreList',
    component: () => import('../views/mycenter/ScoreList.vue'),
    meta: {
      requiresAuth: false,
      keepAlive: true,
      title: 'DV·积分记录'
    }
  },
  {
    path: '/order-list',
    name: 'OrderList',
    component: () => import('../views/mycenter/OrderList.vue'),
    meta: {
      requiresAuth: false,
      keepAlive: true,
      title: 'DV·订单列表'
    }
  },
  {
    path: '/order-detail/:orderNo',
    name: 'OrderDetail',
    component: () => import('@/views/mycenter/OrderDetail.vue'),
    meta: {
      requiresAuth: false,
      keepAlive: false,
      title: 'DV·订单详情'
    }
  },
  {
    path: '/address-list',
    name: 'AddressList',
    component: () => import('../views/mycenter/AddressList.vue'),
    meta: {
      requiresAuth: false,
      keepAlive: true,
      title: 'DV·地址管理'
    }
  },
  {
    path: '/address-detail',
    name: 'AddressDetail',
    component: () => import('@/views/mycenter/AddressDetail.vue'),
    meta: {
      requiresAuth: false,
      keepAlive: false,
      title: 'DV·地址详情'
    }
  },
  {
    path: '/logistics-detail',
    name: 'LogisticsDetail',
    component: () => import('@/views/mycenter/LogisticsDetail.vue'),
    meta: {
      requiresAuth: false,
      keepAlive: false,
      title: 'DV·物流详情'
    }
  },
  {
    path: '/apply-after-sale',
    name: 'ApplyAfterSale',
    component: () => import('@/views/mycenter/ApplyAfterSale.vue'),
    meta: {
      requiresAuth: false,
      keepAlive: false,
      title: 'DV·申请售后'
    }
  },
  {
    path: '/survey-form',
    name: 'SurveyForm',
    component: () => import('@/views/SurveyForm.vue'),
    meta: {
      requiresAuth: false,
      keepAlive: false,
      title: 'DV·问卷调查'
    }
  },
  {
    path: '/lucky-draw-wheel',
    name: 'LuckyDrawWheel',
    component: () => import('@/views/LuckyDrawWheel.vue'),
    meta: {
      requiresAuth: true,
      keepAlive: false,
      title: 'DV·幸运大转盘'
    }
  },
  {
    path: '/win-record-card',
    name: 'WinRecordCard',
    component: () => import('@/components/WinRecordCard.vue'),
    meta: {
      requiresAuth: true,
      keepAlive: false,
      title: 'DV·中奖记录'
    }
  },
  {
    path: '/aisoup',
    name: 'AISoup',
    component: () => import('@/views/AISoup.vue'),
    meta: {
      requiresAuth: true,
      keepAlive: false,
      title: 'DV·智能汤品推荐'
    }
  },
  {
    path: '/soup-detail/:id',
    name: 'SoupDetail',
    component: () => import('@/views/SoupDetail.vue'),
    meta: {
      requiresAuth: true,
      keepAlive: false,
      title: 'DV·汤品详情'
    }
  },
  {
    path: '/message-subscription',
    name: 'MessageSubscription',
    component: () => import('@/views/MessageSubscription.vue'),
    meta: {
      requiresAuth: true,
      keepAlive: false,
      title: 'DV·订阅消息发送'
    }
  },
  {
    path: '/9th-anniversary',
    name: '9thAnniversary',
    component: () => import('@/views/activity/9th-Anniversary/9th-Anniversary.vue'),
    meta: {
      requiresAuth: false,
      keepAlive: true,
      title: 'DV·9周年庆'
    }
  },
  {
    path: '/9th/discount-list',
    name: 'DiscountListFull',
    component: () => import('@/views/activity/DiscountListPage.vue')
  },
  {
    path: '/9th/half-price-list',
    name: 'HalfPriceListFull',
    component: () => import('@/views/activity/HalfPriceListPage.vue'),
    meta: {
      requiresAuth: false,
      keepAlive: false
    }
  },
  // 新增 CouponListPage 路由
  {
    path: '/activity/coupon-list', // 定义路径
    name: 'CouponListFull',       // 定义路由名称
    component: () => import('@/views/activity/CouponListPage.vue'),
    meta: {
      requiresAuth: false,
      keepAlive: false
    }
  },
  // 新增 FruitMarketListPage 路由
  {
    path: '/activity/fruit-market-list', // 水果集市列表页的路径
    name: 'FruitMarketFullList',        // 路由名称，需要和组件中导航使用的名称一致
    component: () => import('@/views/activity/FruitMarketListPage.vue'), // 懒加载页面组件
    meta: {
      requiresAuth: false,             // 是否需要登录，通常列表页不需要
      keepAlive: false,                // 是否缓存页面状态，列表页通常不需要
      title: 'DV·水果集市'              // 页面标题
    }
  },
  // 新增 TeaAlclholMarketListPage 路由
  {
    path: '/activity/tea-alcohol-market-list',
    name: 'TeaAlcoholMarketFullList',
    component: () => import('@/views/activity/TeaAlclholMarketListPage.vue'),
    meta: {
      requiresAuth: false,
      keepAlive: false,
      title: 'DV·茶酒集市'
    }
  },
  // 新增 HealthMarketListPage 路由
  {
    path: '/activity/health-market-list',
    name: 'HealthMarketFullList',
    component: () => import('@/views/activity/HealthMarketListPage.vue'),
    meta: {
      requiresAuth: false,
      keepAlive: false,
      title: 'DV·养生集市'
    }
  },
  // 新增 FoodMarketListPage 路由
  {
    path: '/activity/food-market-list',
    name: 'FoodMarketFullList',
    component: () => import('@/views/activity/FoodMarketListPage.vue'),
    meta: {
      requiresAuth: false,
      keepAlive: false,
      title: 'DV·美食集市'
    }
  },
  // 新增 ClothingMarketListPage 路由
  {
    path: '/activity/clothing-market-list',
    name: 'ClothingMarketFullList',
    component: () => import('@/views/activity/ClothingMarketListPage.vue'),
    meta: {
      requiresAuth: false,
      keepAlive: false,
      title: 'DV·服饰集市'
    }
  },
  // 新增 DragonBoatGiftsListPage 路由
  {
    path: '/activity/dragon-boat-gifts-list',
    name: 'DragonBoatGiftsListPage',
    component: () => import('@/views/activity/DragonBoatGiftsListPage.vue'),
    meta: {
      requiresAuth: false,
      keepAlive: false,
      title: 'DV·端午好礼'
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 全局路由守卫
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = 'DV·生活商城'; // 设置一个默认标题
  }
  next();
});

// 全局后置守卫 - 用于处理微信 JS-SDK 配置
router.afterEach(async (to, from) => {
  // 确保在微信浏览器环境下执行 (包括小程序 web-view)
  if (/micromessenger/i.test(navigator.userAgent.toLowerCase())) {
    console.log('[Router Guard] 路由切换完成，目标路径:', to.fullPath); // 使用 fullPath 获取完整路径

    // 等待下一个 tick 确保 URL 真正更新
    await nextTick();

    const { configJssdk, error } = useWechat({
      autoConfig: false, // 必须是 false，因为我们在守卫中手动调用
      // 定义所有可能需要权限的 JS API 列表
      jsApiList: [
        'updateAppMessageShareData', // 分享给朋友
        'updateTimelineShareData', // 分享到朋友圈
        'getLocation',             // 获取地理位置
        'openLocation',            // 使用微信内置地图查看位置
        'scanQRCode',              // 调起微信扫一扫接口
        'chooseImage',             // 拍照或从手机相册中选图接口
        'previewImage',            // 预览图片接口
        'checkJsApi',              // 判断当前客户端版本是否支持指定JS接口
        'wx-open-launch-weapp'     // 拉起小程序功能
        // ...根据你的应用需要添加其他接口
      ]
    });

    // 获取当前页面的完整 URL，并移除哈希部分
    // 注意：微信 JSSDK 签名需要的是不包含 # 及其后面部分的 URL
    const currentUrl = window.location.href.split('#')[0];
    console.log('[Router Guard] 准备使用 URL 配置 JSSDK:', currentUrl);

    try {
      // 调用配置函数，configJssdk 内部会处理 URL 清理和日志
      const configSuccess = await configJssdk(currentUrl);

      if (configSuccess) {
        console.log('[Router Guard] JSSDK 配置成功 for', to.path);
        // 可选：触发一个全局事件或更新状态管理库(如 Pinia)中的状态
        // window.dispatchEvent(new CustomEvent('wxsdkready', { detail: { path: to.path } }));
      } else {
        console.error('[Router Guard] JSSDK 配置失败 for', to.path, ':', error.value);
        // 可以在这里添加一些用户提示，例如 Toast
        // import { showToast } from 'vant';
        // showToast('微信功能初始化失败，部分功能可能无法使用');
      }
    } catch (e) {
      console.error('[Router Guard] 配置 JSSDK 时发生异常 for', to.path, ':', e);
    }
  }
});

export default router
